<template>
  <div class="clinicSelectorDropdownWrapper">
    <v-select
      v-model="selectedClinicId"
      class="filterSelector"
      :items="allClinics"
      label="Select Clinic"
      item-text="Company"
      item-value="Practice_ID"
    />
  </div>
</template>

<script>
  /* eslint-disable */
import { ApiCalls } from "../../../../../api-calls";
import store from "../../../../../store";

export default {
  name: "ClinicSelectorDropdown",
  props: {
    selectedClinic: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    selectedClinic(val) {
      // practice_ID
      if (val && val.Practice_ID) {
        store.commit("SET_PRACTICE", val.Practice_ID);
        store.commit("SET_POS_PRACTICE", val.Practice_ID);
        this.selectedClinicId = val.Practice_ID;
      } else {
        this.selectedClinicId = "";
      }
    },
    selectedClinicId(val) {
      let selectedClinic = null;
      if (val && val.length) {
        selectedClinic = this.allClinics.find(clinic => clinic.Practice_ID === val);
        this.$emit("update:selectedClinic", selectedClinic);
      }
    }
  },
  data: () => ({
    selectedClinicId: "",
    allClinics: []
  }),
  created() {
    this._loadAllClinics();
  },
  methods: {
    async _loadAllClinics() {
      try {
        const { data } = await ApiCalls.getEligibleClinics();
        this.allClinics = data;
        this.selectedClinicId = this.$store.state.selectedPractice;
      } catch (error) {
        console.log("error", error);
        this.allClinics = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.clinicSelectorDropdownWrapper {
}
</style>
